import React from "react";

function TheTitle() {
    return (
        <h1>Fun facts about React</h1>
    )
}

export default TheTitle;